
/*
Sohel 09/27/2022 2700486402 Trigger Group Trigger group Client and Agency Type Changes
Sohel 09/29/2022 2700486402 Trigger Group Added Toast, validation and Event Trigger Changes
Sohel 10/10/2022 2700486402 Removed unused Code
Sohel 10/12/2022 2700486402 Event Trigger Search Table Payload Changes
Dilip 10/12/2022 2700486402 Trigger Group Fixed GAL- 362 ,364 and label Changes
Sohel 10/14/2022 2700486402 Trigger Group Added Comments
Dilip 10/17/2022 2700486402 Triggers Added tooltip,Changed page options and fixed group code validation issue.
Sohel 10/17/2022 2700486402 Trigger and Trigger Group fixed validation issue ,added tooltip and label changes.
Prakash 10/31/2022 2700486402 Added Pagination for Table.
Sohel 11/02/2022 2699761741 pass props
saikrishna 11/03/2022 2700486402 changed the paginationOptions
Sohel 11/03/2022 2699761741 Table changes and Pass event Type in search payload
Sohel 11/14/2022 2699761741 change table payload
Sohel 11/19/2022 2699761741 mode field payload changes
Prakash 11/21/2022 2699761741 Removed extra Padding.
Akhila 11/23/2022 2699761741 Added Status Column and render only Completed
Suresh Peddavoora 12/01/2022 2699761741 Added ClassName for Draft Status and Removed Inline Styles
Raghu 12/09/2022 2699761741 Table Footer styling fixes
manikanta 01/03/2022 2700430604 save  and close functionality added to  popup
manikanta 01/04/2022 2699761741 fixed  event triggers popup  disable option
Dilip 01/06/2022 2699761741 removed mode column
Gireesh 28/06/2022 2699761741 Fixed DropDown MultiSelection Issue
Guru Prasad 04/04/2023 2699761741 Fixed column widths
*/

import React, {createRef, useEffect, useState} from 'react';
// import MaterialTable from "material-table";
import {Grid, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../../../components/TableIcons';
import {httpPaginationPost} from '../../../../../../util/Rest';
import {useDispatch} from 'react-redux';
import {defaultRows} from '../../../../../../constants/ReusableTablePagination';
import GuiTable from '../../../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../../../constants/ReusableConstants';

export default function SearchEventTacticTable({
  searchData,
  submit,
  setSubmit,
  setSelectedEventTrigger,
  selectedEventTrigger,
  isEventTriggerGroup,
  eventType,
  setSaveData,
  saveData,
}) {
  const columns = [
    {
      title: 'Trigger Name',
      field: 'code',
    },
    {
      title: 'Trigger Description',
      field: 'description',
      headerStyle: {textAlign: 'left', fontSize: 16},
      render: (rowData) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}
          >
            {rowData.description}
          </div>
        </>
      ),
    },
    {
      title: 'Status',
      field: 'isDraft',
      render: (rowData) =>
        rowData?.isDraft === 'N' ?
          <div className="completed-status status"><span>Completed</span></div> : '',
    },
  ];
  const tableRef = createRef();

  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  const maxSelections = 1;
  const handleSelectionProps = (rowData) => {
    return {
      disabled: (isEventTriggerGroup && saveData && saveData?.length >= maxSelections && !rowData.tableData.checked),
    };
  };
  // based on submit update table(2700486402)
  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);
  return (
    <Grid item xs={12}>
      <div className="custom-table custom-toolbar-icons custom-actions-icon global-field-table">
        <GuiTable
          title={''}
          columns={columns}
          icons={tableIcons}
          tableRef={tableRef}
          data={(query) =>
            new Promise((resolve) => {
              const url = `event/search/all`;
              const bodyObj = {
                code: searchData?.code ? searchData.code : '',
                description: searchData?.description ? searchData?.description : '',
                eventType: isEventTriggerGroup ? eventType : 'BATCH',
                mode: searchData?.mode?.value ? searchData?.mode?.value : '',
                limit: query.pageSize ? query.pageSize : null,
                search: query?.search ? query?.search : '',
                isDraft: 'N',
                page: submit ?
                  1 :
                  arrayLast && query?.page >= 1 ?
                    query.page :
                    arrayLast ?
                      (query.page <= 1 && query.page + 1) || query.page - 1 :
                      query.page + 1,
              };
              if (!searchData) {
                resolve({
                  data: [],
                  page: 0,
                  totalCount: 0,
                });
              } else {
                httpPaginationPost(url, bodyObj)
                  .then((response) => {
                    if (response?.status === 200) {
                      const data = response.data.response.resultObject;
                      const eventTrigger = selectedEventTrigger?.map((i) => i?.code);
                      const newRow = response.data?.response?.resultObject?.map((elem) => {
                        if (eventTrigger?.includes(elem?.code)) {
                          return {...elem, tableData: {...elem.tableData, checked: true}};
                        } else {
                          return {
                            ...elem,
                            tableData: {...elem.tableData, checked: false},
                          };
                        }
                      });
                      resolve({
                        data: newRow?.length > 0 ? newRow : [],
                        page: response.data.response.page - 1,
                        totalCount: response.data.response.count,
                      });
                      setArrayLast(data.length === 1);

                      setSubmit(false);
                    } else {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    }
                  })
                  .catch((response) => {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 5,
                    });
                    dispatch({
                      type: 'FETCH_ERROR',
                      payload: response && response.message ? response.message : null,
                    });
                  });
              }
            })
          }
          options={{
            search: false,
            pageSize: rows,
            toolbar: false,
            showSelectAllCheckbox: false,
            emptyRowsWhenPaging: false,
            showTextRowsSelected: false,
            selectionProps: handleSelectionProps,
            selection: true,
            headerStyle: {
              fontWeight: 'bold',
            },
          }}
          onSelectionChange={(rows, row) => {
            if (row?.tableData?.checked) {
              const copyArray = [...saveData];
              copyArray.push(row);
              setSaveData(copyArray);
            } else {
              const copyArray = saveData.filter((el) => el.code !== row.code);
              setSaveData(copyArray);
            }
          }}
          components={{
            Pagination: (props) => (
              <div className="global-field-table-footer">
                <TablePagination
                  {...props}
                  SelectProps={{
                    inputProps: {'aria-label': 'Rows per screen'},
                  }}
                  labelRowsPerPage={'Rows per screen:'}
                  // change page options(2700486402)
                  rowsPerPageOptions={tablePageRows}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                    setRows(event.target.value);
                  }}
                />
              </div>
            ),
          }}
        />
      </div>
    </Grid>
  );
}
